module.exports = __webpack_public_path__ + "static/media/model_about_cs.11e94ce8.jpg";